import React from "react";

const ArrowUpLeft = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#D69700"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round">
        <path d="M17 17L7.8 7.7M7 17V7h10" />
    </svg>
);

export default ArrowUpLeft;
